import React from 'react'
import RButton from '../components/resume-button/RButton'
import linkedin from '../assets/icons/linkedin.png'
import email from '../assets/icons/email.png'
import github from '../assets/icons/github.png'
import eye from '../assets/icons/eye.png'
import leetcode from '../assets/icons/leetcode.png'
import '../assets/fonts/fonts.css'

const Home = () => {
    const dotMarkup = {
        height: '5px',
        width: '5px',
        backgroundColor: 'gray',
        borderRadius: '50%',
        display: 'inline-block',
        marginTop: '11px',
    };
    return (
        <div className='w-full flex flex-col justify-center items-center bg-gray-800' id='home' style={{ height: '92.6vh' }}>
            <div className='text-6xl md:text-8xl text-white font-normal baloo'>Sai Charan</div>
            <div className='flex' style={{ color: 'gray' }}>
                <p className="mx-5 md:mx-7" >Node.js</p>
                <span style={dotMarkup}></span>
                <p className="mx-5 md:mx-7">React</p>
                <span style={dotMarkup}></span>
                <p className="mx-5 md:mx-7">C++</p>
            </div>
            <div className='flex justify-between items-center w-56 mt-4'>
                <img src={linkedin} className='h-7 cursor-pointer' alt="linkedin"
                    onClick={() => {
                        window.open('https://www.linkedin.com/in/saicharan0662/', '_blank')
                    }}
                />
                <a href="mailto:saicharan0662@gmail.com">
                    <img src={email} className='h-8 cursor-pointer' alt="email" />
                </a>
                <img src={github} className='h-8 cursor-pointer' alt="github"
                    onClick={() => {
                        window.open('https://github.com/Saicharan0662/', '_blank')
                    }}
                />
                <img src={leetcode} className='h-8 cursor-pointer' alt="leetcode"
                    onClick={() => {
                        window.open('https://leetcode.com/Saicharan062002/', '_blank')
                    }}
                />
            </div>
            <RButton
                buttonText="View resume"
                icon={eye}
                onClick={() => {
                    window.open('https://drive.google.com/file/d/1T3_QkpNU_pdfOqZ-pNOewL63ypEx9vxo/view?usp=sharing', '_blank')
                }}
            />
        </div>
    )
}

export default Home
